<script>
// Components
import Header from '@src/components/header/_header.vue'
import SideBar from '@src/components/side-bar/_side-bar.vue'
import ButtonLoader from '@src/components/loader/button-loader.vue'
import RightPanel from '@src/components/right-panel/right-panel.vue'
// helpers
import { getSavedState } from '@src/utils/localStorage'
import { baseComputed } from '@state/helpers/base.js'
export default {
    components: {
        'mgb-header': Header,
        'mgb-side-navbar': SideBar,
        'button-loader': ButtonLoader,
        'right-panel': RightPanel,
    },
    props: {
        hideTitle: { type: Boolean, default: false },
    },
    computed: {
        ...baseComputed,
    },
    created() {
        this.checkLocation()
    },
    methods: {
        checkLocation() {
            if (!getSavedState('auth.selectedLocation'))
                this.$router.push('/choose-location')
        },
    },
}
</script>

<template>
    <div class="app-wrapper">
        <div class="app-overlay" :class="{ active: isOverlayActive }" />
        <b-row
            no-gutters
            class="position-relative"
            :class="{ 'overflow-hidden': isOverlayActive }"
        >
            <b-col>
                <button-loader
                    v-if="this.$route.name !== 'Menu.assessmentApplication'"
                    :active="isLoading"
                ></button-loader>
                <mgb-side-navbar />
                <mgb-header :hide-title="hideTitle" />
                <div class="main-container" :class="{ 'no-title': hideTitle }">
                    <b-container fluid>
                        <slot />
                    </b-container>
                </div>
            </b-col>
            <!-- right panel: filtros e áreas de upload e download -->
            <right-panel />
        </b-row>
    </div>
</template>
